<template>
    <div class="home-card-content">
        <div class="card-head">
            <div class="card-name">{{name}}</div>
            <div class="card-sub-name">{{subName}}</div>
            <div v-if="showMore" class="show-more" @click="$router.push(showMore)">更多{{type|parseType}} <i class="el-icon-d-arrow-right"></i></div>
        </div>
        <swiper v-if="type===1" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item,index) in dataList" :key="index">
                <component :is="currentCom" :url="item.image" :item="item" :name="item.name"></component>
            </swiper-slide>
        </swiper>
        <div v-else class="card-content">
            <template v-for="(item,index) in dataList">
                <component :is="currentCom" :key="index" v-if="index<=11" :item="item"></component>
            </template>
        </div>
    </div>
</template>

<script>
    import CityCard from "@/components/CityCard";
    import HouseCard from "@/components/HouseCard";
    import LineCard from "@/components/LineCard";
    import HotelCard from "@/components/HotelCard";
    export default {
        name: "HomeCardContent",
        components:{CityCard, HouseCard, LineCard, HotelCard},
        props:{
            name: {
                type: String,
                default: ''
            },
            subName: {
                type: String,
                default: ''
            },
            dataList: {
                type: Array,
                default(){
                    return []
                }
            },
            type: {
                type: Number,
                default: 1
            },
            showMore:{
                type: String,
                default: ''
            }
        },
        data(){
            return{
            }
        },
        computed:{
            currentCom(){
                if(this.type === 1){
                    return 'CityCard'
                }else if(this.type === 2){
                    return 'HouseCard'
                }else if(this.type === 3){
                    return 'LineCard'
                }else if(this.type === 4){
                    return 'HotelCard'
                }
                return 'HouseCard'
            },
            swiperOptions(){
                return {
                    slidesPerView: this.type === 1 ? 5 : 4
                }
            }
        },
        filters:{
            parseType(data){
                switch (data) {
                    case 1:
                        return '';
                    case 2:
                        return '房源';
                    case 3:
                        return '实惠'
                    case 4:
                        return '酒店'
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .home-card-content{
        width: 1200px;
        margin: auto;
        .card-head{
            width: 100%;
            padding-bottom: 20px;
            padding-top: 50px;
            height: 120px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            .card-name{
                font-size: 32px;
                font-weight: bold;
                margin-right: 20px;
            }
            .card-sub-name{
                font-size: 16px;
                color: #949494;
            }
            .show-more{
                font-size: 14px;
                margin-left: 30px;
                cursor: pointer;
                &:hover{
                    color: #e44646;
                }
            }
        }
    }
    .card-content{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }
</style>
